#@export Booking

# Prepare namespace
window.Booking ?= {}

window.Booking.rootUrl     ?= "/booking"
window.Booking.Collections ?= {}
window.Booking.Helpers     ?= {}
window.Booking.Models      ?= {}
window.Booking.Presenters  ?= {}
window.Booking.Views       ?= {}
